import { useRouter, useRouterState } from '@tanstack/react-router'
import { PageTitle } from '@/components/ui'
import { linkTarget } from '@/lib/links'

/**
 * Where an outside link lands first (`/leave?to=<url>`): a link Prime wrote in
 * a thread, or a notification that carries one. It says where it goes and waits
 * for a tap; only http and https are ever offered.
 */
export const LeaveView = () => {
  const router = useRouter()
  const search = useRouterState({ select: (s) => s.location.searchStr })
  const to = new URLSearchParams(search).get('to') ?? ''
  const t = linkTarget(to)
  const out = t?.kind === 'out' ? t : null
  const cancel = () => {
    if (window.history.length > 1) router.history.back()
    else void router.navigate({ to: '/' })
  }
  return (
    <div>
      <PageTitle eyebrow="Link">{out ? 'Leaving alfieOS' : 'Not a link I can open'}</PageTitle>
      {out ? (
        <>
          <p className="text-[15px] text-fg-2" data-testid="leave-host">
            This opens <strong className="text-fg">{out.host}</strong>, outside alfieOS.
          </p>
          <p className="mt-2 text-xs text-faint break-all" data-testid="leave-url">
            {out.url}
          </p>
          <div className="mt-5 flex gap-3">
            <a
              href={out.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 min-h-11 inline-flex items-center justify-center rounded-[var(--radius-control)] bg-accent text-on-accent font-medium"
              data-testid="leave-open"
            >
              Open
            </a>
            <button
              type="button"
              onClick={cancel}
              className="flex-1 min-h-11 rounded-[var(--radius-control)] bg-raised text-fg"
              data-testid="leave-cancel"
            >
              Cancel
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="text-[15px] text-fg-2" data-testid="leave-refused">
            Only web addresses (http or https) open from here.
          </p>
          <button
            type="button"
            onClick={cancel}
            className="mt-5 min-h-11 px-5 rounded-[var(--radius-control)] bg-raised text-fg"
          >
            Back
          </button>
        </>
      )}
    </div>
  )
}
